import React, { useState, useEffect } from "react";
import ticketyLogo from "../../assets/HelpNexis__2_-removebg-preview.png";
import ticketyFavicon from "../../assets/favicon.png";
import { useNavigate } from "react-router-dom";
import "./Navbar.scss";

const Navbar = () => {
  const [isActive, setIsActive] = useState("Home");
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 786);
  const navigate = useNavigate();

  //Update state on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 786);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavClick = (e, sectionId) => {
    setIsActive(sectionId);
    setMenuOpen(false);
  };

  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const options = {
      root: null,
      threshold: 0.1,
      rootMargin: "-20% 0px -20% 0px",
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsActive(entry.target.id);
        }
      });
    }, options);

    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return (
    <div className="navbar">
      {/* Logo */}
      <div className="logo">
        <img
          src={ticketyLogo}
          alt="tickety-logo"
          onClick={(e) => e.stopPropagation()}
        />
      </div>

      {/* Navigation Links */}
      <div className={`nav-links ${menuOpen ? "active" : ""}`}>
        <a
          href="#home"
          className={isActive === "home" ? "clicked" : "unClicked"}
          onClick={(e) => handleNavClick(e, "home")}
        >
          Home
        </a>
        <a
          href="#services"
          className={isActive === "services" ? "clicked" : "unClicked"}
          onClick={(e) => handleNavClick(e, "services")}
        >
          Services
        </a>
        <a
          href="#tutorial"
          className={isActive === "tutorial" ? "clicked" : "unClicked"}
          onClick={(e) => handleNavClick(e, "tutorial")}
        >
          Tutorial
        </a>

        {/* Mobile Login Button */}
        {isMobile && (
          <div className="log-in">
            <button className="lgInBtn" onClick={() => navigate("/login")}>
              Log In
            </button>
          </div>
        )}
      </div>
      {/* Desktop Login Button + Menu Icon for Mobile */}
      <div className="sideMenu">
        {!isMobile && (
          <div className="log-in">
            <button className="lgInBtn" onClick={() => navigate("/login")}>
              Log In
            </button>
          </div>
        )}

        <div
          className="menu-icon"
          onClick={() => {
            setMenuOpen(!menuOpen);
          }}
        >
          ☰
        </div>
      </div>
    </div>
  );
};

export default Navbar;
